import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { MessageHandlerService } from "../../services/message-handler.service";
import { EventEmitter } from "@angular/core";
import { StatisticFinanceData } from "../data/statisticsFinance";

@Injectable()
export class StatisticFinanceService extends StatisticFinanceData {
  emitter: EventEmitter<any> = new EventEmitter();
  api: string;
  apiCampaign: string;
  header: any;
  constructor(
    private http: HttpClient,
    private messageHandler: MessageHandlerService
  ) {
    super();
    this.api = environment.apiUrl;
  }

  async getTotalLeads(dateStart: any, dateEnd: any ,  leadTime: string) {
    try {
      let response = await this.http
        .post(this.api + "finance/statistics/tot", { dateStart, dateEnd, leadTime})
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getTotalLeadsId(dateStart: any, dateEnd: any, id: any, leadTime: string) {
    try {
      let response = await this.http
        .post(this.api + "finance/statistics/tot/" + id, { dateStart, dateEnd, leadTime })
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getDayLeadsOffer(dateStart: any, dateEnd: any, leadTime: string) {
    try {
      let response = await this.http
        .post(this.api + "finance/statistics/daily/offer", { dateStart, dateEnd, leadTime })
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getDayLeadsOfferId(dateStart: any, dateEnd: any, id: any, leadTime: string) {
    try {
      let response = await this.http
        .post(this.api + "finance/statistics/daily/offer/" + id, { dateStart, dateEnd, leadTime })
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getTotalLeadsOffer(dateStart: any, dateEnd: any, leadTime: string) {
    try {
      let response = await this.http
        .post(this.api + "finance/statistics/offer", { dateStart, dateEnd, leadTime})
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getTotalLeadsOfferId(dateStart: any, dateEnd: any, id: any, leadTime: string) {
    try {
      let response = await this.http
        .post(this.api + "finance/statistics/offer/" + id, { dateStart, dateEnd, leadTime })
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getDayLeadsRef(dateStart: any, dateEnd: any, leadTime: string) {
    try {
      let response = await this.http
        .post(this.api + "finance/statistics/daily/ref", { dateStart, dateEnd , leadTime})
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getDayLeadsRefId(dateStart: any, dateEnd: any, id: any, leadTime: string) {
    try {
      let response = await this.http
        .post(this.api + "finance/statistics/daily/ref/" + id, { dateStart, dateEnd, leadTime })
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }


  async getTotalLeadsRef(dateStart: any, dateEnd: any, leadTime: string) {
    try {
      let response = await this.http
        .post(this.api + "finance/statistics/ref", { dateStart, dateEnd , leadTime})
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getTotalLeadsRefId(dateStart: any, dateEnd: any, id: any, leadTime: string) {
    try {
      let response = await this.http
        .post(this.api + "finance/statistics/ref/" + id, { dateStart, dateEnd, leadTime })
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }


  async getDayLeadsCampaign(dateStart: any, dateEnd: any, leadTime: string) {
    try {
      let response = await this.http
        .post(this.api + "finance/statistics/daily/campaignName", { dateStart, dateEnd , leadTime})
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getDayLeadsCampaignId(dateStart: any, dateEnd: any, id: any, leadTime: string) {
    try {
      let response = await this.http
        .post(this.api + "finance/statistics/daily/campaignName/" + id, { dateStart, dateEnd , leadTime})
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }


  async getTotalLeadsCampaign(dateStart: any, dateEnd: any, leadTime: string) {
    try {
      let response = await this.http
        .post(this.api + "finance/statistics/campaignName", { dateStart, dateEnd , leadTime})
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }

  async getTotalLeadsCampaignId(dateStart: any, dateEnd: any, id: any, leadTime: string) {
    try {
      let response = await this.http
        .post(this.api + "finance/statistics/campaignName/" + id, { dateStart, dateEnd , leadTime})
        .toPromise();
      return response;
    } catch (e) {
      this.messageHandler.error(e);
      throw new Error(e.error.message);
    }
  }
}
